import { FunctionComponent, memo } from "react";
import { IProps } from "./agent-selection-list.types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { NumericValue } from "@edgetier/client-components";
import classNames from "classnames";
import "./agent-selection-list.scss";

/**
 * Show list of agents
 * @param props.label
 * @param props.items
 * @param props.isSelectedList
 * @param props.moveAction
 */
const AgentSelectionList: FunctionComponent<IProps> = ({
    label,
    items,
    moveAction,
    isSelectedList = true,
    isSearchActive,
}) => {
    return (
        <div
            className={classNames("select-menu__list", {
                "select-menu__list--selected": isSelectedList,
            })}
        >
            <div className="select-list-title">
                {label}
                <span>
                    (<NumericValue value={items.length} />)
                </span>
            </div>
            <ul>
                {isSearchActive && items.length === 0 && (
                    <li>
                        <div className="select-menu__options--empty">No agents found</div>
                    </li>
                )}

                {items
                    .sort((itemOne, itemTwo) => itemOne.name.localeCompare(itemTwo.name))
                    .map((agent) => (
                        <li key={agent.agentId}>
                            <div className={"select-menu__option"} onClick={() => moveAction(agent)}>
                                {isSelectedList && <FontAwesomeIcon icon={faChevronLeft} />}
                                <div className="select-menu__option__label">
                                    <div>{agent.name}</div>
                                    {typeof agent.email === "string" && (
                                        <div className="select-agent__email">{agent.email}</div>
                                    )}
                                </div>
                                {!isSelectedList && <FontAwesomeIcon icon={faChevronRight} />}
                            </div>
                        </li>
                    ))}
            </ul>
        </div>
    );
};

export default memo(AgentSelectionList);
